import { all, call, put, takeLatest } from 'redux-saga/effects';
import {
    deleteTagError,
    deleteTagRequest,
    deleteTagSuccess,
    getTagsError,
    getTagsRequest,
    getTagsSuccess,
} from './index';
import { AxiosResponse } from 'axios';
import { deleteTag, getTags } from '../api/tagsApi';

export function* getTagsSaga(params: any) {
    const entityType = params.payload;

    try {
        const response: AxiosResponse = yield call(getTags, entityType);
        yield put(getTagsSuccess(response));
    } catch (error) {
        yield put(getTagsError(error));
    }
}

export function* deleteTagSaga(params: any) {
    const { id, entityType } = params.payload;

    try {
        yield call(deleteTag, id, entityType);
        yield put(deleteTagSuccess());
        yield put(getTagsRequest(entityType));
    } catch (error) {
        yield put(deleteTagError(error));
    }
}

export default function* tagsSagaWatcher() {
    yield all([takeLatest(getTagsRequest, getTagsSaga), takeLatest(deleteTagRequest, deleteTagSaga)]);
}
